const initialState = () => ({
  page: 1,
  // NACH tab filter param sent to backend: created | success | failed
  nach_status: "created",
  selected_tab: 0,
  // Date range filter (on NACH created date)
  display_daterange: "",
  date_range: [],
  // Dedicated per-field filters (mirror the common "Filters" panel pattern)
  token_id: "",
  order_id: "",
  payment_id: "",
  customer_id: "",
  // Select-user filter: chosen borrower lead id
  lead: "",
  // Company: the borrower's employer, typed free-hand
  employer_name: "",
});

export default {
  namespaced: true,
  state: initialState(),

  mutations: {
    RESET_FILTERS(state) {
      Object.assign(state, initialState());
    },
  },
  actions: {
    resetFilters({ commit }) {
      commit("RESET_FILTERS");
    },
  },
  getters: {
    // Fresh copy of the filter defaults; used by filterChipsMixin's
    // dev coverage guard to detect applied-but-unregistered filters.
    getInitialFilters: () => initialState(),
    getFilters: (state) => {
      return state;
    },
  },
};
